<template>
  <div>
    <slot />
    <GlobalWarningModal />

    <ImportContactsOneschemaModal v-if="isLoggedIn && isOneSchemaEnabled" />
    <ImportContactsModal v-else-if="isLoggedIn" />

    <OneSchemaEventImportModal v-if="isLoggedIn && isOneSchemaEnabled" />

    <ImportEventDataModal v-if="isLoggedIn" />
    <ImportProductDataModal v-if="isLoggedIn" />
    <FailedImportModal v-if="isLoggedIn" />
    <CancellationModal v-if="isLoggedIn" />
    <DeleteModal v-if="isLoggedIn" />
    <CancelScheduleModal v-if="isLoggedIn" />
    <MultipleButtonModal v-if="isLoggedIn" />
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

import GlobalWarningModal from '@/components/modals/general/global-warning-modal/';
import MultipleButtonModal from '@/components/modals/general/multiple-button-modal/';
import CancellationModal from '@/components/modals/general/cancellation-modal/CancellationModal';
import DeleteModal from '@/components/modals/general/delete-modal/DeleteModal';
import ImportContactsModal from '@/components/modals/audience/import-contacts-modal/';
import ImportContactsOneschemaModal from '@/components/modals/audience/import-contacts-oneschema-modal'
import ImportEventDataModal from '@/components/modals/event/import-event-data-modal/';
import ImportProductDataModal from '@/components/modals/event/import-product-data-modal/';
import CancelScheduleModal from '@/components/modals/message/cancel-schedule-modal/';
import FailedImportModal from '@/components/modals/event/failed-rows/';
import OneSchemaEventImportModal from '@/components/modals/event/oneschema-event-import-modal';

export default {
  name: 'ModalsExpansion',
  components: {
    GlobalWarningModal,
    ImportContactsModal,
    ImportEventDataModal,
    ImportProductDataModal,
    FailedImportModal,
    CancellationModal,
    DeleteModal,
    CancelScheduleModal,
    MultipleButtonModal,
    ImportContactsOneschemaModal,
    OneSchemaEventImportModal,
  },
  computed: {
    ...mapState({
      account: state => state.auth.account,
    }),
    ...mapGetters({
      isFeatureEnabled: 'auth/isFeatureEnabled',
    }),
    isOneSchemaEnabled() {
      return this.isFeatureEnabled(['oneschema']);
    },
    isLoggedIn() {
      if (!this.account) {
        return false;
      }
      return Object.keys(this.account).length > 0;
    },
  },
};
</script>
